import {IPaymentLinkInformation, PaymentLinkModel} from '../entities';

export const mapPaymentLinkToTrackingInformation = (
  data: PaymentLinkModel,
): IPaymentLinkInformation => {
  return {
    id: data.receiver_user?.id ?? '',
    receiver_user: {
      id: data.receiver_user?.id ?? '',
    },
    amount: data.amount,
    single_payment: data.single_payment,
    status: data.status,
    information: {
      note: data.note,
      gif: data.gif,
    },
    link_consumed: data?.link_consumed,
  };
};
